export class MailingListPersonModel implements IMailingListPersonModel {
  id?: string | undefined;
  personId?: string | undefined;
  mailingListId?: string | undefined;
  dateCreated?: Date | undefined;
  dateUpdated?: Date | undefined;
  dateLastEmailed?: Date | undefined;
  addedById?: string | undefined;

  constructor(data?: IMailingListPersonModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      this.id = Data["id"];
      this.personId = Data["personId"];
      this.mailingListId = Data["mailingListId"];
      this.dateCreated = Data["dateCreated"] ? new Date(Data["dateCreated"].toString()) : <any>undefined;
      this.dateUpdated = Data["dateUpdated"] ? new Date(Data["dateUpdated"].toString()) : <any>undefined;
      this.dateLastEmailed = Data["dateLastEmailed"] ? new Date(Data["dateLastEmailed"].toString()) : <any>undefined;
      this.addedById = Data["addedById"];
    }
  }

  static fromJS(data: any): MailingListPersonModel {
    data = typeof data === 'object' ? data : {};
    let result = new MailingListPersonModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["personId"] = this.personId;
    data["mailingListId"] = this.mailingListId;
    data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
    data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toISOString() : <any>undefined;
    data["dateLastEmailed"] = this.dateLastEmailed ? this.dateLastEmailed.toISOString() : <any>undefined;
    data["addedById"] = this.addedById;
    return data;
  }
}

export interface IMailingListPersonModel {
  id?: string | undefined;
  personId?: string | undefined;
  mailingListId?: string | undefined;
  dateCreated?: Date | undefined;
  dateUpdated?: Date | undefined;
  dateLastEmailed?: Date | undefined;
  addedById?: string | undefined;
}